import React, { useEffect } from "react";
import PropTypes from "prop-types";
import EChallanTrafficFines from "../e-challan-traffic-fines";
import EChallaneTrafficRules from "../../shared/e-challan-traffic-rules";
import EChallanBreadCrumb from "../../shared/e-challan-breadcrumb";
import PageNotFound from "../../shared/page-not-found";
import EChallanMetaTags from "../../shared/e-challan-meta-tags";
import EChallanStates from "../e-challan-states";
import styles from "./styles.css";
import EChallanHeroBannerV2 from "../state-e-challan-hero-banner";
import StateEChallanHowToCheck from "../state-e-challan-how-to-check";
import StateEChallanOnlinePayment from "../state-e-challan-online-payment";
import EChallanFaqsVariant from "../e-challan-faq-variant";
import StateEChallanBenefits from "../state-e-challan-benefits";
import StateEChallanComplaint from "../state-e-challan-complaint";
import StateEChallanTransaction from "../state-e-challan-transaction";
import StateEChallanTables from "../state-e-challan-tables";
import { NUMBER } from "../../../constants/app-constants";
import EChallanRecentTransaction from "../e-challan-recent-transaction";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";

const StateEChallan = ({
    stateName,
    stateSlug,
    isInvalidState,
    history,
    isSSR = false,
    cmsContent = {},
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    fetchRegNumberListConnect,
    fetchOrderDataConnect
}) => {
    useC2bCleverTap("Pay_challan");

    useEffect(() => {
        if (isLoggedIn) {
            if (!isSSR) {
                fetchRegNumberListConnect(secureToken);
            }
            if (!recentTransaction || !isSSR) {
                fetchOrderDataConnect(secureToken);
            }
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [isLoggedIn]);

    if (isInvalidState) return <PageNotFound />;

    const {
        heroBannerData = {},
        seo = [],
        howToCheckChallanData = {},
        howToPayStateChallanData = {},
        trafficRules = {},
        eChallanComplaint = {},
        eChallanTransaction = {},
        challanBenefitsData = {},
        challanStateListData = {},
        challanFaqData = {},
        topOffenses = {}
    } = cmsContent || {};

    const {metaTitle = "", metaDescription = ""} = seo?.[0] || {};

    return (
        <React.Fragment>
            <EChallanMetaTags
                history={history}
                metaTitle={metaTitle}
                metaDescription={metaDescription}
            />
            <EChallanHeroBannerV2 heroBannerData={heroBannerData} regNumberList={regNumberList} isState />
            {!!recentTransaction && <EChallanRecentTransaction orderData={recentTransaction} />}
            <StateEChallanHowToCheck howToCheckChallanData={howToCheckChallanData} />
            <StateEChallanOnlinePayment howToPayStateChallanData={howToPayStateChallanData} />
            <EChallanTrafficFines isDesktop />
            <StateEChallanTables topOffenses={topOffenses} threshold={NUMBER.FOUR} />
            <EChallaneTrafficRules isDesktop stateName={stateName} trafficRules={trafficRules} />
            <StateEChallanComplaint eChallanComplaint={eChallanComplaint} />
            <StateEChallanTransaction eChallanTransaction={eChallanTransaction} />
            <StateEChallanBenefits challanBenefitsData={challanBenefitsData} />

            <div styleName={"styles.eChallanStates"}>
                <EChallanStates title={challanStateListData?.title} stateSlug={stateSlug} />
            </div>

            <EChallanFaqsVariant challanFaqData={challanFaqData} />

            <EChallanBreadCrumb
                stateName={stateName}
                stateSlug={stateSlug}
            />
        </React.Fragment>
    );
};

StateEChallan.propTypes = {
    stateName: PropTypes.string,
    stateSlug: PropTypes.string,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    isInvalidState: PropTypes.bool,
    history: PropTypes.object,
    title: PropTypes.string,
    cmsContent: PropTypes.object,
    regNumberList: PropTypes.object,
    recentTransaction: PropTypes.object,
    isSSR: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchRegNumberListConnect: PropTypes.func,
    fetchOrderDataConnect: PropTypes.func
};

export default StateEChallan;

